import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconSortAZ$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconSortAZ extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '97de68e141dae19f5e795b45cb9f9b3708bfb604', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: 'f1d962baa5f009461240978b83f60997a921e150', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: 'd93fb6603026b0cbc5856e22c9ed33c6c31d06c7', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M7.75 14h2.284a.4.4 0 0 1 .283.683l-3.034 3.034a.4.4 0 0 1-.566 0l-3.034-3.034A.4.4 0 0 1 3.966 14H6.25V4.5a.5.5 0 0 1 .5-.5h.5a.5.5 0 0 1 .5.5zm9.94 3.67v-.77a.36.36 0 0 0-.36-.36h-2.77l2.99-2.73c.1-.097.158-.23.16-.37v-.77a.36.36 0 0 0-.36-.36h-4.62a.36.36 0 0 0-.36.36v.77a.36.36 0 0 0 .36.36h2.73l-2.94 2.73a.5.5 0 0 0-.16.37v.77a.35.35 0 0 0 .35.36h4.62a.36.36 0 0 0 .36-.36m-1.78-8.935H14.1l-.23.7a.42.42 0 0 1-.4.29h-1.04a.265.265 0 0 1-.27-.39l1.85-5.06a.4.4 0 0 1 .39-.27h1.2a.4.4 0 0 1 .39.27l1.85 5.06a.265.265 0 0 1-.27.39h-1.04a.4.4 0 0 1-.4-.29zm-1.45-1.2.54-1.89.56 1.89z", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-sort-a-z", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-sort-a-z"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-sort-a-z":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconSortAZ$1);
            }
            break;
    } });
}

const CosmosIconSortAZ = CosmosIconSortAZ$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconSortAZ, defineCustomElement };
